import * as React from 'react';
import HeaderPaneProps from './HeaderPaneProps';
import { DiagnosticsPanel } from 'owa-diagnostics';

const DiagnosticsPane: React.SFC<HeaderPaneProps> = props => {
    return <DiagnosticsPanel onDismiss={props.onDismiss} />;
};

export default DiagnosticsPane;
